<template>
    <v-footer app class="amber lighten-1">

        <v-row style="background-color: #526C5C; color: white;"
            justify="center"
            align="center"
            >
            <slot><span ></span></slot>
        </v-row>
    </v-footer>
</template>
<script>
    export default {
        props: {},
        data() {
            return {}
        },
        mounted() {
        },
        computed: {},
        methods: {},

        components: {},
        filters: {}
    }
</script>
